module.exports = __webpack_public_path__ + "static/media/opiniao_comprador_6.8f3227a8.png";